import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, Slide, TextareaAutosize, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CoachAPI } from '../../../api/CoachAPI';
import { useSelector } from 'react-redux';
import { RiImageEditFill } from 'react-icons/ri';
import TeamCard from './TeamCard';
import Loader from "../../../component/Loader.jsx"
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer.js';
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx';
import * as Yup from 'yup';
import { Privileges } from '../../../util/PrivilegeConstants.js';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import { isClubOwner, isClubStaff, isCoach } from '../../../util/UserRoles.js';
import { CalendarAPI } from '../../../api/CalendarAPI.js';

const validationObj = Yup.object({
    teamName: Yup.string().required("Team Name is required"),
    teamDesc: Yup.string().required("Team Description is required")
})

const TeamList = () => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [openDialog, setOpenDialog] = useState({ isOpen: false, isEdit: false });
    const [data, setData] = useState({});
    const [teams, setTeams] = useState([]);
    const [imagePre, setImagePre] = useState('');
    const [image, setImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({})
    const [privileges, setPrivileges] = useState({});

    const dispatch = useDispatch();

    const handleCollectData = (event) => {
        const { name, value } = event.target;
        setData({ ...data, [name]: value });
    }
    const handleOpenEditPopup = (val) => {
        setData(val);
        setImagePre(val.teamLogo ? `${import.meta.env.VITE_APP_BASE_URL}/team/logo/${val.teamLogo}` : ``)
        setOpenDialog({ isOpen: true, isEdit: true });

    };
    const findAllPrivileges = async () => {
        try {
            setIsLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[16]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleCreateTeam = async () => {
        try {
            await validationObj.validate(data, { abortEarly: false });
            setIsLoading(true);
            const response = await CoachAPI.postCreateTeam({
                teamName: data.teamName,
                createdBy: userInfo.userId,
                clubId: selectedClub.clubId,
                teamDesc: data.teamDesc
            }, image);
            setTeams(prev => [...prev, response.Data]);
            setOpenDialog(false);
            setData({})
        } catch (error) {
            if (error.inner) {
                let errorObj = {}
                error.inner.forEach(err => {
                    errorObj[err.path] = err.message
                })
                setFieldErrors(errorObj);
            }
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleEditTeam = async () => {
        try {
            await validationObj.validate(data, { abortEarly: false });
            setIsLoading(true);
            const reqObject = {
                teamId: data.teamId,
                teamName: data.teamName,
                createdBy: userInfo.userId,
                clubId: selectedClub.clubId,
                teamDesc: data.teamDesc
            }
            const response = await CoachAPI.putUpdateTeam(reqObject, image);
            setTeams(prev => prev.map(item => item.teamId === data.teamId ? response.Data : item));
            setOpenDialog(false);
            setData({})
        } catch (error) {
            if (error.inner) {
                let errorObj = {}
                error.inner.forEach(err => {
                    errorObj[err.path] = err.message
                })
                setFieldErrors(errorObj);
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        const maxSizeInMB = 5;
        if (file.type === "image/webp" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {

            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > maxSizeInMB) {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'info', content: "upload image under 5 MB" }));
            }
            else {
                setImage(file);
                setImagePre(URL.createObjectURL(file));
            }
        } else {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: "upload .jpg, .jpeg, .png, .gif,.webp file" }));
        }
    };
    const findAllTeamByClub = async () => {
        try {
            setIsLoading(true);

            const configResponse = await CalendarAPI.getCalendarConfigCoachPrivacy(selectedClub.clubId);
            let teamResponse;

            if (configResponse.Data && !isClubOwner(userInfo) && !isClubStaff(userInfo)) {
                teamResponse = await CoachAPI.findAllTeamByCoach(selectedClub.clubId, userInfo.userId);
            } else {
                teamResponse = await CoachAPI.findAllTeamByClubId(selectedClub.clubId);
            }

            setTeams(teamResponse.Data);
        } catch (error) {
            console.error("Failed to fetch teams:", error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (selectedClub.clubId && userInfo.userId) {
            findAllTeamByClub();
            findAllPrivileges();
        }
    }, [selectedClub.clubId, userInfo.userId]);

    return (
        <div className='sm_team_list_con'>
            {isLoading && <Loader />}
            <div className='sm_team_list_body'>
                <div className='sm_team_list_header'>
                    <h1>Teams</h1>
                   {privileges?.MANAGE_TEAM?.includes(Privileges.CREATE) &&
                    <button onClick={() => setOpenDialog({ isOpen: true, isEdit: false })}>Create Team</button>}
                </div>
                {teams?.length == 0 ?
                    <div className='sm_team_crad_no_player_found'>
                        <p> No team on the field yet. Assemble your squad and start playing to win!</p>
                    </div>
                    :
                    <div className='sm_team_crad_list'>
                        {teams?.map((team, index) =>
                            <TeamCard privileges={privileges} handleOpenEditPopup={handleOpenEditPopup} key={index} team={team} />)}
                    </div>}
            </div>
            <CustomDialog
                title="Enter Your Team Details"
                isOpen={openDialog.isOpen}
                onClose={() => {
                    setOpenDialog({ isOpen: false, isEdit: false });
                    setData({})
                    setFieldErrors({})
                }}
                onCancel={() => {
                    setOpenDialog({ isOpen: false, isEdit: false });
                    setData({})
                    setFieldErrors({})
                }}
                onSubmit={openDialog.isEdit ? handleEditTeam : handleCreateTeam}
                submitBtnName={openDialog.isEdit ? 'Save' : 'Create'}
            >
                <div className="sm_add_team_form" >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="user-profile-image">
                            <label htmlFor="file_upload" className="profile_image_edit">
                                <RiImageEditFill className="profile_image_edit_icon" />
                            </label>
                            <label className="profile_image_preview">
                                <img
                                    loading="lazy"
                                    src={imagePre}
                                    alt=""
                                />
                            </label>
                            <input
                                type="file"
                                id="file_upload"
                                name="image"
                                onChange={handleImageUpload}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <TextField fullWidth
                            className="add-member-text-input"
                            error={fieldErrors['teamName']}
                            helperText={fieldErrors['teamName'] && fieldErrors['teamName']}
                            variant="outlined"
                            value={data.teamName || ''}
                            onChange={handleCollectData}
                            label='Team Name *'
                            name='teamName' />
                    </div>


                    <TextField fullWidth
                        multiline
                        minRows={3}
                        className="add-member-text-input"
                        error={fieldErrors['teamDesc']}
                        helperText={fieldErrors['teamDesc'] && fieldErrors['teamDesc']}
                        variant="outlined"
                        name="teamDesc"
                        value={data.teamDesc || ''}
                        onChange={handleCollectData}
                        label='Team Description *'
                    />
                </div>
            </CustomDialog>
        </div>
    )
}

export default TeamList